import {useCallback} from 'react';
import {useIsExtraLargeAndUp} from '~library/hooks/useMatchQuery';

const SIZE_CLASSES = Object.freeze({
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
});

const isUsingProxy = (url = '') => url?.includes('/api/imagey/');

export const useImageProxySizer = () => {
  const isExtraLargeAndUp = useIsExtraLargeAndUp();

  const getThumbnailUrl = useCallback(
    (url) => (isUsingProxy(url) ? `${url}/${SIZE_CLASSES.SMALL}` : url),
    []
  );
  const getDisplayUrl = useCallback(
    (url) => {
      if (isUsingProxy(url)) {
        if (isExtraLargeAndUp) return `${url}/${SIZE_CLASSES.LARGE}`;
        return `${url}/${SIZE_CLASSES.MEDIUM}`;
      }
      return url;
    },
    [isExtraLargeAndUp]
  );

  return {
    getThumbnailUrl,
    getDisplayUrl,
  };
};
